/**
 * @generated SignedSource<<40ee9deca348ef387b20d73970df38cf>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeliverNotificationRuleInput = {
  notificationGroupUUIDs?: ReadonlyArray<any> | null | undefined;
  notificationRuleUUIDs?: ReadonlyArray<any> | null | undefined;
};
export type DeliverNotificationRuleMutation$variables = {
  input: DeliverNotificationRuleInput;
};
export type DeliverNotificationRuleMutation$data = {
  readonly deliverNotificationRule: {
    readonly problems: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type DeliverNotificationRuleMutation = {
  response: DeliverNotificationRuleMutation$data;
  variables: DeliverNotificationRuleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeliverNotificationRuleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "DeliverNotificationRulePayload",
        "kind": "LinkedField",
        "name": "deliverNotificationRule",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "DeliverNotificationRuleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "DeliverNotificationRulePayload",
        "kind": "LinkedField",
        "name": "deliverNotificationRule",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "12c6001d35042a0f11000092c9e2cd68",
    "id": null,
    "metadata": {},
    "name": "DeliverNotificationRuleMutation",
    "operationKind": "mutation",
    "text": "mutation DeliverNotificationRuleMutation(\n  $input: DeliverNotificationRuleInput!\n) {\n  deliverNotificationRule(input: $input) {\n    problems {\n      __typename\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9f4f3506e8f29077bba1f7401dc9c20e";

export default node;
